/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_InformationInputs */

const en_contact_information = /** @type {(inputs: Contact_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Information`)
};

const fr_contact_information = /** @type {(inputs: Contact_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations de contact`)
};

const de_contact_information = /** @type {(inputs: Contact_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktinformationen`)
};

const it_contact_information = /** @type {(inputs: Contact_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni sui contatti`)
};

const ru_contact_information = /** @type {(inputs: Contact_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контактная информация`)
};

const es_contact_information = /** @type {(inputs: Contact_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información del contacto`)
};

const zh_cn2_contact_information = /** @type {(inputs: Contact_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系信息`)
};

const ja_contact_information = /** @type {(inputs: Contact_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連絡先`)
};

const hi_contact_information = /** @type {(inputs: Contact_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपर्क जानकारी`)
};

const pt_pt2_contact_information = /** @type {(inputs: Contact_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações de contato`)
};

/**
* | output |
* | --- |
* | "Contact Information" |
*
* @param {Contact_InformationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const contact_information = /** @type {((inputs?: Contact_InformationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_InformationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_contact_information(inputs)
	if (locale === "de") return de_contact_information(inputs)
	if (locale === "it") return it_contact_information(inputs)
	if (locale === "ru") return ru_contact_information(inputs)
	if (locale === "es") return es_contact_information(inputs)
	if (locale === "zh-CN") return zh_cn2_contact_information(inputs)
	if (locale === "ja") return ja_contact_information(inputs)
	if (locale === "hi") return hi_contact_information(inputs)
	if (locale === "pt-PT") return pt_pt2_contact_information(inputs)
	return en_contact_information(inputs)
});